const timeDifference = (start, end) => {
    const difference = end - start;
    const chargingWindow = difference <= 0
        ? difference + 24
        : difference;

    return chargingWindow;    
}

export default timeDifference;